/**
 * Polygon drawing functions for country boundaries
 * Phase 4.2: Polygon Rendering
 */

/**
 * Draw a single polygon (country path)
 * @param {PIXI.Graphics} graphics - PixiJS Graphics object
 * @param {Float32Array} coords - [x0,y0, x1,y1, ...] in screen space
 * @param {Array<number>} color - RGB [0-255]
 * @param {boolean} stroke - Whether to draw outline
 */
export function drawPolygon(graphics, coords, color, stroke = false) {
    if (coords.length < 4) return; // Need at least 2 points

    // Convert RGB to hex
    const colorHex = (color[0] << 16) | (color[1] << 8) | color[2];

    graphics.beginFill(colorHex, 1.0);

    if (stroke) {
        graphics.lineStyle(0.5, 0x000000, 0.2); // Thin black border
    }

    // Start path
    graphics.moveTo(coords[0], coords[1]);

    // Draw remaining vertices
    for (let i = 2; i < coords.length; i += 2) {
        graphics.lineTo(coords[i], coords[i + 1]);
    }

    // Close path
    graphics.closePath();
    graphics.endFill();
}
